function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { useMarkets } from '@applyboard/business-ui-legacy';
import MarketsContext from "./MarketsContext";
import { id, studyVisaTitle, commonName } from "../../Common/Constants";
export var formatMarketsData = function formatMarketsData(data) {
  return data.map(function (marketData) {
    var _ref;
    return _ref = {}, _defineProperty(_ref, id, marketData[id]), _defineProperty(_ref, studyVisaTitle, marketData.attributes.studyVisaTitle), _defineProperty(_ref, commonName, marketData.attributes.commonName), _ref;
  });
};
var MarketsProvider = function MarketsProvider(_ref2) {
  var children = _ref2.children;
  var _useMarkets = useMarkets(),
    markets = _useMarkets.markets,
    isLoadingMarkets = _useMarkets.isLoadingMarkets;
  var marketsData = formatMarketsData(markets);
  var value = {
    data: marketsData,
    isLoading: isLoadingMarkets
  };
  return /*#__PURE__*/React.createElement(MarketsContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement("div", null, children));
};
export default MarketsProvider;